var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.293 9.70722C10.4805 9.89469 10.7348 10 11 10C11.2652 10 11.5195 9.89469 11.707 9.70722L15.707 5.70722C15.8945 5.51969 15.9998 5.26538 15.9998 5.00022C15.9998 4.73505 15.8945 4.48074 15.707 4.29322L11.707 0.293217C11.5184 0.111059 11.2658 0.0102645 11.0036 0.0125427C10.7414 0.014821 10.4906 0.11999 10.3052 0.305398C10.1198 0.490806 10.0146 0.741619 10.0123 1.00382C10.01 1.26601 10.1108 1.51861 10.293 1.70722L12.586 4.00022L1 4.00021C0.734785 4.00021 0.480431 4.10557 0.292894 4.29311C0.105358 4.48064 1.02924e-06 4.735 9.77393e-07 5.00021C9.25547e-07 5.26543 0.105358 5.51978 0.292894 5.70732C0.48043 5.89486 0.734784 6.00021 1 6.00021L12.586 6.00022L10.293 8.29322C10.1055 8.48074 10.0002 8.73505 10.0002 9.00022C10.0002 9.26538 10.1055 9.51969 10.293 9.70722Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.9c2184c5dbde39a30af01b2e4ff577d8.svg";
export { ForwardRef as ReactComponent };